import React from 'react';
// Control Masters moved to Organisation → Masters tab (see OrgMasters).
import ControlOverview from '../../../components/internalControls/ControlOverview';
import ControlRegisterTab from '../../../components/internalControls/ControlRegisterTab';
import ControlDeficiencies from '../../../components/internalControls/ControlDeficiencies';
import ControlTesting from '../../../components/internalControls/ControlTesting';
import ControlPrograms from '../../../components/internalControls/ControlPrograms';
import ITATTemplates from '../../../components/itAssessment/ITATTemplates';
import ITATPrograms from '../../../components/itAssessment/ITATPrograms';
import ComingSoon from '../../../components/common/ComingSoon';
import CadenceRuleList from '../../../components/cadence/CadenceRuleList';
import { CADENCE_MODULE_TYPES } from '../../../components/cadence/cadenceModuleTypes';
import '../../../components/layout/ModuleLayout.css';
import { ICTabKey } from './InternalControlsTabs';

interface InternalControlsNetBodyProps {
  activeTab?: ICTabKey;
}

const InternalControlsNetBody: React.FC<InternalControlsNetBodyProps> = ({ activeTab = 'overview' }) => {
  const renderPanel = () => {
    if (activeTab === 'overview')     return <ControlOverview />;
    if (activeTab === 'library')      return <ControlRegisterTab />;
    if (activeTab === 'deficiencies') return <ControlDeficiencies />;
    if (activeTab === 'testing')      return <ControlTesting />;
    if (activeTab === 'programs')     return <ControlPrograms />;
    if (activeTab === 'ita-templates') return <ITATTemplates />;
    if (activeTab === 'ita-programs')  return <ITATPrograms />;
    if (activeTab === 'cadence')      return <CadenceRuleList allowedTypeCodes={CADENCE_MODULE_TYPES.control} />;
    return <ComingSoon message="Controls content will be rolled out iteratively across design, testing, and deficiency remediation." />;
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default InternalControlsNetBody;
